// @ngInject
function OrderService() {


    return {
        canShipOrder: canShipOrder,
        canDeleteOrder: canDeleteOrder,
        canCopyOrder: canCopyOrder,
        canEditOrder: canEditOrder,
        canDeliverOrder: canDeliverOrder,
        canApproveOrder : canApproveOrder,
        isDeliveryPlanningEnabled: isDeliveryPlanningEnabled,
        canPartDeliverOrder: canPartDeliverOrder,
        updateCurrencyOnOrderRows: updateCurrencyOnOrderRows,
        hasQuantity: hasQuantity,
        isInternalOrder: isInternalOrder,
        createOrderRowsFromArticleVariants: createOrderRowsFromArticleVariants,
        canConfirmDeliveryPlan: canConfirmDeliveryPlan,
        canUndoConfirmDeliveryPlan: canUndoConfirmDeliveryPlan,
        canChangePredictedDate: canChangePredictedDate,
        isLeadTimeDeliveryPlan: isLeadTimeDeliveryPlan,
    };

    function hasLink(links, rel) {
        var link = _.find(links, function (o) {
            return o.rel === rel;
        });

        if (link) {
            return true;
        }

        return false;
    }
    function isLeadTimeDeliveryPlan(links) {
        return hasLink(links, 'is_lead_time');
    }
    function canConfirmDeliveryPlan(links) {
        return hasLink(links, 'confirmed');
    }
    function canUndoConfirmDeliveryPlan(links) {
        return hasLink(links, 'undo_confirmed');
    }
    function canChangePredictedDate(links) {
        return hasLink(links, 'predicted_changeable');
    }

    function canDeliverOrder(links) {
        return hasLink(links, 'deliver');
    }

    function isDeliveryPlanningEnabled(links) {
        return hasLink(links, 'deliveryplan');
    }

    function canEditOrder(links) {
        return hasLink(links, 'update');
    }

    function canDeleteOrder(links) {
        return hasLink(links, 'delete');
    }

    function canApproveOrder(links) {
        return hasLink(links, 'approve');
    }

    function canCopyOrder(links) {
        return hasLink(links, 'copy');
    }

    function canPartDeliverOrder(links) {
        return hasLink(links, 'part_deliver');
    }

    function canShipOrder(links) {
        return hasLink(links, 'ship');
    }

    function isInternalOrder(order) {
        return order.orderType.orderSystemType === 'internal';
    }

    function updateCurrencyOnOrderRows(orderArticles, currency) {
        _.forEach(orderArticles, function (orderArticle) {
            _.forEach(orderArticle.orderRows, function (row) {
                row.purchaseCost = (((((row.originalPurchasePrice * (1 - row.discountPercent/100)) * currency) + row.shippingCost) * (1 + row.customsPercent/100)) + row.otherCosts) * (1 + row.standardCostAddPercent/100);
            });
        });
    }

    function hasQuantity(orderArticles) {
        var totalQuantity = 0;
        _.forEach(orderArticles, function (orderArticle) {
            _.forEach(orderArticle.orderRows, function (row) {
               totalQuantity += row.quantity;
            });
        });

        return (totalQuantity > 0);
    }

    function createOrderRowsFromArticleVariants(order, articleVariants, orderArticle, stocks) {
        var orderRows = [];

        var currencyRate = order.currencyRate;

        if (order.company && order.company.id) {
            var companyId = order.company.id;
        }

        var articleVariantIds = [];
        _.forEach(articleVariants, function(av) { articleVariantIds.push(av.id); });
        var locationIds = [];
        if (order.fromLocation) {
            locationIds.push(order.fromLocation.id);
        }

        var orderRowWithComment = _.find(orderArticle.orderRows, function(row){
            return row.comment !== "" || row.comment !== undefined || row.comment !== null;
        })
        var orderRowComment = orderRowWithComment ? orderRowWithComment.comment : undefined;

        _.forEach(articleVariants, function(articleVariant) {
            var supplierPrice;

            var orderRow = {
                id: 0,
                articleVariant: articleVariant,
                destination: (order.orderType.orderSystemType.toLowerCase() !== 'return') ? order.destination : order.fromLocation,
                quantity: 0,
                deliveryRows: [],
                summarizedDeliveredQuantity: 0,
                orderStatus: { orderSystemStatus: 'Created' },
                status: 'Created',
                comment: orderRowComment,
            };

            if (articleVariant.supplierPrices != null && articleVariant.supplierPrices.length > 0) {
                supplierPrice = _.find(articleVariant.supplierPrices, function(sp) { return sp.companyId === companyId; });
            }

            if (supplierPrice === undefined) {
                // we only have the price in SEK, convert it back to the order currency.
                //orderRow.purchaseCost = articleVariant.purchaseCost;
                orderRow.discountPercent = 0;
                orderRow.standardCostAddPercent = 0;
                orderRow.effectivePurchasePrice = articleVariant.purchaseCost / ((100 + orderRow.standardCostAddPercent) / 100);
                orderRow.originalPurchasePrice = orderRow.effectivePurchasePrice / ((100 - orderRow.discountPercent) / 100);
                orderRow.shippingCost = 0;
                orderRow.customsPercent = 0;
                orderRow.otherCosts = 0;
                // calculate the total row sum..
                orderRow.purchaseCost = getTotalRowSum(orderRow, currencyRate);
            } else if (supplierPrice.purchasePrice === 0) {
                // we only have the price in SEK, convert it back to the order currency.
                //orderRow.purchaseCost = articleVariant.purchaseCost;
                orderRow.discountPercent = 0;
                orderRow.standardCostAddPercent = 0;
                orderRow.effectivePurchasePrice = articleVariant.purchaseCost / ((100 + orderRow.standardCostAddPercent) / 100);
                orderRow.originalPurchasePrice = orderRow.effectivePurchasePrice / ((100 - orderRow.discountPercent) / 100);
                orderRow.shippingCost = 0;
                orderRow.customsPercent = 0;
                orderRow.otherCosts = 0;
                // calculate the total row sum..
                orderRow.purchaseCost = getTotalRowSum(orderRow, currencyRate);
            } else {
                // convert forwards to SEK
                orderRow.originalPurchasePrice = supplierPrice.purchasePrice;
                orderRow.standardCostAddPercent = supplierPrice.standardCostAddPercent;
                orderRow.discountPercent = supplierPrice.discountPercent;
                orderRow.effectivePurchasePrice = orderRow.originalPurchasePrice * ((100 - orderRow.discountPercent) / 100);
                // orderRow.purchaseCost = (orderRow.effectivePurchasePrice + ((orderRow.standardCostAddPercent) / 100) * orderRow.effectivePurchasePrice) * currencyRate;
                orderRow.shippingCost = supplierPrice.shippingCost;
                orderRow.customsPercent = supplierPrice.customsPercent;
                orderRow.otherCosts = supplierPrice.otherCosts;
                orderRow.purchaseCost = getTotalRowSum(orderRow, currencyRate);
            }

            if (order.destination && order.destination.resellerPriceList && order.destination.resellerPriceList.priceListItems) {
                //Prices on the reseller price list trumps all other prices
                var resellerPriceListCurrencyRate = order.destination.resellerPriceList.currencyRate;
                var resellerPriceListItem = _.find(order.destination.resellerPriceList.priceListItems, function(pli) {
                    return pli.articleVariantId === articleVariant.id;
                });
                if (resellerPriceListItem) {
                    orderRow.purchaseCost = resellerPriceListItem.price;
                    orderRow.discountPercent = resellerPriceListItem.discountPercent;
                    orderRow.standardCostAddPercent = resellerPriceListItem.standardCostAddPercent;
                    orderRow.effectivePurchasePrice = (resellerPriceListItem.price) / ((100 + orderRow.standardCostAddPercent) / 100);
                    orderRow.originalPurchasePrice = orderRow.effectivePurchasePrice / ((100 - orderRow.discountPercent) / 100);
                    orderRow.shippingCost = resellerPriceListItem.shippingCost;
                    orderRow.customsPercent = resellerPriceListItem.customsPercent;
                    orderRow.otherCosts = resellerPriceListItem.otherCosts;
                }
            }

            // Stock purchase cost trumps even reseller prices for internal orders
            if (order.orderType.orderSystemType.toLowerCase() === 'internal') {
                var stock = _.find(stocks, function(st) { return st.articleVariant.id === articleVariant.id && st.location.id === order.fromLocation.id; });
                if (stock !== undefined) {
                    orderRow.purchaseCost = stock.purchaseCost;
                    orderRow.discountPercent = 0;
                    orderRow.standardCostAddPercent = 0;
                    orderRow.effectivePurchasePrice = stock.purchaseCost;
                    orderRow.originalPurchasePrice = stock.purchaseCost;
                    orderRow.shippingCost = 0;
                    orderRow.customsPercent = 0;
                    orderRow.otherCosts = 0;
                }
            }

            orderRows.push(orderRow);
        });

        return orderRows;

        function calculateEffectivePurchasePrice(originalPurchasePrice, discountPercent) {
            var discountAmount = (originalPurchasePrice * discountPercent / 100);
            return originalPurchasePrice - discountAmount;
        }
    
        function getTotalRowSum(rowItem, currencyRate) {
            var pp = calculateEffectivePurchasePrice(rowItem.originalPurchasePrice, rowItem.discountPercent);
            var ppCurrencyConverted = pp * currencyRate;
            var customsAmount = (ppCurrencyConverted + rowItem.shippingCost) * (rowItem.customsPercent / 100);
            var standardCostAddAmount = (ppCurrencyConverted + rowItem.shippingCost + customsAmount + rowItem.otherCosts) * (rowItem.standardCostAddPercent / 100);
    
            var result = ppCurrencyConverted + rowItem.shippingCost + customsAmount + rowItem.otherCosts + standardCostAddAmount;
    
            return result;
        }
    }
}

angular
    .module('order.service', [])
    .factory('OrderService', OrderService);
